/**
 * Module: GalleryDetail
 *
 * Calls Utility.isElementInViewIO in order to add Lazyloading
 *
 * Returned Functions: init, openDetailview
 *
 */
var Acr = Acr || {};

Acr.GalleryDetail = function () {


  var $element;
  var $acrDetailVideoPlayer;
  var $acrDetailPictureSlick;
  var $acrDetailFilmstripSlick;
  var $acrDetailFilmstripPrev;
  var $acrDetailFilmstripNext;
  var $acrDetailCloseBtn;
  var $acrGalleryDetailFilmstrip;
  var $acrGalleryDetailFilmstripWrapper;
  var $acrDetailFilmstripItem;
  var $acrDetailIndex;
  var $acrDetailPictureShadow;
  var $galleryDetailText;
  var $showPictureInfoBtn;
  var $enlargePictureBtn;
  var $detailBackgroundImage;
  var $detailVideoWrapper;
  var $detailWrapper;
  var $pictureContainer;
  var $videoContainer;
  var $galleryDetailLightbox;
  var $hashLinks;
  var $documentBody;
  var $window;
  var direction = '';
  var resizeTimer;
  var ieResizeTimer;
  var ieOrWinEdge;

  var acrDetailVideoPlayerList;
  var acrDetailFilmstripItemClassName;

  const acrDetailFilmstripSlickClass = '.js-acr-detail-filmstrip-slick';
  const acrDetailCarouselSlickClass = '.js-acr-detail-carousel-slick';
  const acrDetailIndexClass = '.js-acr-detail-index';
  const acrDetailCloseBtnClass = '.js-acr-detail-close-btn';
  const svgDefiniion = 'http://www.w3.org/2000/svg';
  const acrDetailLoadedClass = 'acr-gallery-detail--loaded';
  const acrDetailOpenedClass = 'acr-gallery-detail--opened';
  const modalOpenClass = 'modal-open';
  const arrowRightClass = 'arrow-right';
  const arrowLeftClass = 'arrow-left';
  const acrDetailFilmstripItemClass = '.js-acr-detail-filmstrip-item';
  const acrDetailVideoPlayerClass = '.js-acr-detail-video';
  const acrDetailFilmstripPrevClass = '.js-acr-detail-filmstrip-prev';
  const acrDetailFilmstripNextClass = '.js-acr-detail-filmstrip-next';
  const acrGalleryDetailFilmstripClass = '.js-gallery-detail-filmstrip';
  const acrGalleryDetailFilmstripWrapperClass = '.js-gallery-detail-filmstrip-wrapper';
  const acrGalleryDetailTextClass = '.js-gallery-detail-text';
  const acrDetailhoverClass = 'js-shadow-hover';
  const acrDetailPictureShadowClass = '.acr-gallery-detail__picture-shadow';
  const detailWrapperClass = '.js-acr-detail-wrapper';
  const showPictureInfoBtnSelectorClass = '.js-show-picture-info-btn';
  const visibleShowPictureInfoBtnStyleClass = 'acr-gallery-detail__pic-info-btn-show--visible';
  const enlargePictureBtnSelectorClass = '.js-enlarge-picture-btn';
  const visibleEnlargePictureBtnStyleClass = 'acr-gallery-detail__pic-info-btn-enlarge--visible';
  const backgroundImageSelectorClass = '.js-gallery-detail-background-image';
  const videoWrapperSelectorClass = '.js-gallery-detail-video-wrapper';
  const pictureContainerSelectorClass = '.js-gallery-detail-picture-container';
  const videoContainerSelectorClass = '.js-gallery-detail-video-container';
  const lightboxSelectorClass = '.js-gallery-detail-lightbox';
  const detailWrapperModifierClass = 'acr-gallery-detail__wrapper--full';
  const backgroundImageModifierClass = 'acr-gallery-detail__background-image--large';
  const videoWrapperModifierClass = 'acr-gallery-detail__video-wrapper--large';
  const pictureContainerModifierClass = 'acr-gallery-detail__picture-container--large';
  const videoContainerModifierClass = 'acr-gallery-detail__video-container--large';
  const galleryDetailTextModifierClass = 'acr-gallery-detail__detail--hidden';
  const lightboxModifierClass = 'acr-gallery-detail__lightbox--large';
  const hashLinks = 'a[href*="#"]';
  const fullViewPaddingTop = 0.51; // This is the padding top for full view of the "acr-gallery-detail__background-image" class that is in the scss file.
  const detailViewPaddingTop = 0.57; // This is the padding top for detail view of the "acr-gallery-detail__background-image" class that is in the scss file.

  function openDetailview(imageId, index, isCustomIndex) { // If isCustomIndex, the component opens the image associated with the imageId parameter
    var indexTarget;

    if (isCustomIndex) {
      var imageToGo = $acrDetailPictureSlick.find('#' + imageId);
      var imageIndex = imageToGo.data('index');
      indexTarget = imageIndex !== undefined ? imageIndex : 0;
    } else {
      indexTarget = index !== undefined ? index : 0;
    }

    $element.addClass(acrDetailOpenedClass);
    $documentBody.addClass(modalOpenClass);
    history.replaceState('', document.title, window.location.pathname + window.location.search);
    if (!$element.hasClass(acrDetailLoadedClass)) {
      initDetailSlick();
      initDetailAdditionalSelectors();
      attachFilmstripWidth();
      bindFilmstripEvents();
      bindDetailPictureEvents();
      startVideos();
      $element.addClass(acrDetailLoadedClass);
    }

    if (ieOrWinEdge) {
      $($window).on('resize', bindEdgeIEEvents);
      if (Utility.isDesktop()) {
        var detailWrapperWidth = $detailWrapper.outerWidth();
        var carouselHeight = parseInt((detailWrapperWidth * fullViewPaddingTop), 10);
        $detailWrapper.css('height', carouselHeight);
      }
    }

    slickDetailGoTo(indexTarget);
    slickFilmstripGoTo(indexTarget);
    attachKeyboardInput();
    $($window).on('resize', modalResizeHandler);
    $showPictureInfoBtn.attr('slide-index', 'Slide ' + (indexTarget + 1));
    $enlargePictureBtn.attr('slide-index', 'Slide ' + (indexTarget + 1));
  }

  function updateIndex(number) {
    var currentNumber = number || 0;
    $acrDetailIndex.text(currentNumber);
  }

  function goToNextPage() {
    var currentItems;
    var currentVisibleItems;
    var currentSlide;
    var filmstripWidth;
    var filmstripItemWidth;
    const slideMargin = 5;

    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    currentSlide = $acrDetailFilmstripSlick.slick('slickCurrentSlide');

    currentItems = $acrDetailFilmstripItem.length;
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));

    slickFilmstripGoTo((currentVisibleItems + currentSlide) % currentItems);
  }

  function goToPrevPage() {
    var currentItems;
    var currentVisibleItems;
    var currentSlide;
    var filmstripWidth;
    var filmstripItemWidth;
    var position;
    const slideMargin = 5;

    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    currentSlide = $acrDetailFilmstripSlick.slick('slickCurrentSlide');

    currentItems = $acrDetailFilmstripItem.length;
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));
    position = currentSlide - currentVisibleItems;

    slickFilmstripGoTo(position < 0 ? currentItems + position : position);
  }

  function slickFilmstripGoTo(index, dontAnimate) {
    var dontAnimateTransition = dontAnimate || true;
    var filmstripWidth = $acrDetailFilmstripSlick.width();
    var filmstripItemWidth = $acrDetailFilmstripItem.width();

    if ((filmstripItemWidth * $acrDetailFilmstripItem.length) > filmstripWidth) {
      $acrDetailFilmstripSlick.slick('slickGoTo', index, dontAnimateTransition);
    }

    executeLazyLoading();
  }

  function executeLazyLoading() {
    var imagesToLoad = [].slice.call(document.querySelectorAll(acrDetailFilmstripItemClass + ' img[loading="lazy"]'));
    Utility.initLazyLoadingIO(imagesToLoad, Acr.LazyLoadingHelper.loadImage);
  }

  function slickDetailGoTo(index, dontAnimate) {
    var dontAnimateTransition = dontAnimate || true;
    $acrDetailPictureSlick.slick('slickGoTo', index, dontAnimateTransition);
  }

  function addFakeSlickCurrent() {
    var index;
    index = $acrDetailPictureSlick.find('.slick-current').attr('data-slick-index');
    $acrDetailFilmstripSlick.find('.slick-slide').removeClass('slick-fake-current');
    $acrDetailFilmstripSlick.find('[data-index="' + index + '"]').addClass('slick-fake-current');
  }

  function isSelectedItemVisible() {
    var currentVisibleItems;
    var minIndex;
    var maxIndex;
    var currentIndex;
    var fakeDataIndex;
    var filmstripWidth;
    var filmstripItemWidth;

    const slideMargin = 5;

    fakeDataIndex = $acrDetailFilmstripSlick.find('.slick-fake-current.slick-active').attr('data-slick-index');
    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    minIndex = $acrDetailFilmstripSlick.slick('slickCurrentSlide');

    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));
    maxIndex = currentVisibleItems + minIndex;
    currentIndex = fakeDataIndex;

    if (currentIndex) {
      return !(currentIndex >= maxIndex || currentIndex < minIndex);
    }

    return false;
  }

  function getPagePosition(direction) {
    var currentDirection;
    var index;
    var filmstripWidth;
    var filmstripItemWidth;
    var currentVisibleItems;
    var currentItems;
    var slideOffset;
    const slideMargin = 5;

    currentDirection = direction === 'left' ? 'left' : 'right';

    filmstripWidth = $acrDetailFilmstripSlick.width();
    filmstripItemWidth = $acrDetailFilmstripItem.width();
    index = $acrDetailFilmstripSlick.find('.slick-fake-current').attr('data-index');
    currentItems = $acrDetailFilmstripItem.length;

    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));

    if (currentDirection === 'right') {
      return index;
    }
    index = index - currentVisibleItems + 1;
    slideOffset = currentItems + ((((currentVisibleItems + index) % currentItems)) - currentVisibleItems);
    return index > 0 ? index : slideOffset;

  }

  function addModalMeasures() {
    var filmstripHeight;
    var carouselHeight;
    var galleryDetailTextWidth;
    var detailWrapperWidth;

    filmstripHeight = $acrGalleryDetailFilmstrip.outerHeight();
    galleryDetailTextWidth = $galleryDetailText.outerWidth();
    detailWrapperWidth = $detailWrapper.outerWidth();

    if (Utility.isDesktop()) {
      if ($detailWrapper.hasClass(detailWrapperModifierClass)) {
        $pictureContainer.css('width', detailWrapperWidth);
        $videoContainer.css('width', detailWrapperWidth);
        $detailBackgroundImage.addClass(backgroundImageModifierClass);
        $detailVideoWrapper.addClass(videoWrapperModifierClass);
        $galleryDetailText.css('left', detailWrapperWidth);
        carouselHeight = parseInt(detailWrapperWidth * fullViewPaddingTop, 10);
        $detailWrapper.css('height', carouselHeight);
        $galleryDetailLightbox.css('height', carouselHeight);
        $enlargePictureBtn.removeClass(visibleEnlargePictureBtnStyleClass);
        $showPictureInfoBtn.addClass(visibleShowPictureInfoBtnStyleClass);
      } else {
        $pictureContainer.css('width', detailWrapperWidth - galleryDetailTextWidth);
        $videoContainer.css('width', detailWrapperWidth - galleryDetailTextWidth);
        $detailBackgroundImage.removeClass(backgroundImageModifierClass);
        $detailVideoWrapper.removeClass(videoWrapperModifierClass);
        $galleryDetailText.css('left', detailWrapperWidth - galleryDetailTextWidth);
        carouselHeight = parseInt((detailWrapperWidth - galleryDetailTextWidth) * detailViewPaddingTop, 10);
        $detailWrapper.css('height', filmstripHeight + carouselHeight);
        $galleryDetailLightbox.css('height', carouselHeight);
        $showPictureInfoBtn.removeClass(visibleShowPictureInfoBtnStyleClass);
        $enlargePictureBtn.addClass(visibleEnlargePictureBtnStyleClass);
      }
    } else {
      removeEdgeIEInlineStyles();
      $detailBackgroundImage.removeClass(backgroundImageModifierClass);
      $detailVideoWrapper.removeClass(videoWrapperModifierClass);
    }
  }

  function removeEdgeIEInlineStyles() {
    $pictureContainer.removeAttr('style');
    $videoContainer.removeAttr('style');
    $galleryDetailText.removeAttr('style');
    $detailWrapper.removeAttr('style');
    $galleryDetailLightbox.removeAttr('style');
  }

  function bindEdgeIEEvents() {
    clearTimeout(ieResizeTimer);
    ieResizeTimer = setTimeout(function () {
      addModalMeasures();
    }, 250);
  }

  function bindDetailPictureEvents() {
    $acrDetailPictureSlick.on('afterChange', function () {
      var isSelectedItemVisibleFlag;
      var index;
      pauseVideos();
      addFakeSlickCurrent();

      isSelectedItemVisibleFlag = isSelectedItemVisible();

      if (!isSelectedItemVisibleFlag && direction === 'right') {
        index = getPagePosition(direction);
        slickFilmstripGoTo(index);

      } else if (!isSelectedItemVisibleFlag && direction === 'left') {
        index = getPagePosition(direction);
        slickFilmstripGoTo(index);
      }
    });

    $acrDetailPictureSlick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var decl = currentSlide - nextSlide;

      if (decl === 1 || decl === (slick.slideCount - 1) * (-1)) {
        direction = 'left';
      } else {
        direction = 'right';
      }

      updateIndex(nextSlide + 1);
      $showPictureInfoBtn.attr('slide-index', 'Slide ' + (nextSlide + 1));
      $enlargePictureBtn.attr('slide-index', 'Slide ' + (nextSlide + 1));
      $acrDetailPictureShadow.removeAttr('style');
    });

    $('.' + acrDetailhoverClass).hover(
      function () {
        $acrDetailPictureShadow.css('opacity', 0.6);
      },
      function () {
        $acrDetailPictureShadow.removeAttr('style');
      },
    );
  }

  function bindFilmstripEvents() {
    $acrDetailFilmstripSlick.on('click', acrDetailFilmstripItemClassName, function (e) {
      e.preventDefault();
      var $target;
      var index;

      $target = $(this);
      index = $target.data('index');
      slickDetailGoTo(index, false);
      addFakeSlickCurrent();
    });

    $acrDetailFilmstripNext.on('click', function (e) {
      e.preventDefault();
      goToNextPage();
    });

    $acrDetailFilmstripPrev.on('click', function (e) {
      e.preventDefault();
      goToPrevPage();
    });
  }

  function initPictureInfoBtns() {
    if (!ieOrWinEdge) {
      $showPictureInfoBtn.on('click', function (event) {
        event.preventDefault();
        showPictureInfoHandler();
      });

      $enlargePictureBtn.on('click', function (event) {
        event.preventDefault();
        enlargePictureHandler();
      });
    } else {
      $showPictureInfoBtn.on('click', function (event) {
        event.preventDefault();
        showPictureInfoIEHandler();
      });

      $enlargePictureBtn.on('click', function (event) {
        event.preventDefault();
        enlargePictureIEHandler();
      });
    }
  }

  function showPictureInfoHandler() {
    $detailWrapper.removeClass(detailWrapperModifierClass);
    $pictureContainer.removeClass(pictureContainerModifierClass);
    $videoContainer.removeClass(videoContainerModifierClass);
    $detailBackgroundImage.removeClass(backgroundImageModifierClass);
    $detailVideoWrapper.removeClass(videoWrapperModifierClass);
    $galleryDetailText.removeClass(galleryDetailTextModifierClass);
    $galleryDetailLightbox.removeClass(lightboxModifierClass);
    $showPictureInfoBtn.removeClass(visibleShowPictureInfoBtnStyleClass);
    $enlargePictureBtn.addClass(visibleEnlargePictureBtnStyleClass);
  }

  function enlargePictureHandler() {
    $detailWrapper.addClass(detailWrapperModifierClass);
    $detailBackgroundImage.addClass(backgroundImageModifierClass);
    $detailVideoWrapper.addClass(videoWrapperModifierClass);
    $pictureContainer.addClass(pictureContainerModifierClass);
    $videoContainer.addClass(videoContainerModifierClass);
    $galleryDetailText.addClass(galleryDetailTextModifierClass);
    $galleryDetailLightbox.addClass(lightboxModifierClass);
    $enlargePictureBtn.removeClass(visibleEnlargePictureBtnStyleClass);
    $showPictureInfoBtn.addClass(visibleShowPictureInfoBtnStyleClass);
  }

  function showPictureInfoIEHandler() {
    $detailWrapper.removeClass(detailWrapperModifierClass);
    addModalMeasures();
  }

  function enlargePictureIEHandler() {
    $detailWrapper.addClass(detailWrapperModifierClass);
    addModalMeasures();
  }

  function initCloseBtn() {
    $acrDetailCloseBtn.on('click', function (event) {
      event.preventDefault();
      closeHandler();
    });
  }

  function closeHandler() {
    $documentBody.removeClass(modalOpenClass);
    $element.removeClass(acrDetailOpenedClass);
    stopVideos();
    $(document).off('keyup', keyboardHandler);
    $($window).off('resize', modalResizeHandler);
    $($window).off('resize', bindEdgeIEEvents);
    enlargePictureHandler();
    if (ieOrWinEdge) {
      removeEdgeIEInlineStyles();
    }
  }

  function initDeeplink() {
    $hashLinks.on('click', function (event) {
      var currentUrl = window.location.pathname;
      currentUrl = currentUrl.substr(currentUrl.length - 1) === '/' ? currentUrl.pop() : currentUrl;

      if (currentUrl === event.target.pathname) {
        $documentBody.removeClass(modalOpenClass);
        $element.removeClass(acrDetailOpenedClass);
        stopVideos();
      }
    });
  }

  function initSelectors(element) {
    $element = $(element);
    $acrDetailPictureSlick = $element.find(acrDetailCarouselSlickClass);
    $acrDetailFilmstripSlick = $element.find(acrDetailFilmstripSlickClass);
    $acrDetailVideoPlayer = $element.find(acrDetailVideoPlayerClass);
    $acrDetailCloseBtn = $element.find(acrDetailCloseBtnClass);
    $acrDetailFilmstripNext = $element.find(acrDetailFilmstripNextClass);
    $acrDetailFilmstripPrev = $element.find(acrDetailFilmstripPrevClass);
    $acrDetailFilmstripItem = $element.find(acrDetailFilmstripItemClass);
    $acrDetailIndex = $element.find(acrDetailIndexClass);
    $acrDetailPictureShadow = $element.find(acrDetailPictureShadowClass);
    $acrGalleryDetailFilmstrip = $element.find(acrGalleryDetailFilmstripClass);
    $acrGalleryDetailFilmstripWrapper = $element.find(acrGalleryDetailFilmstripWrapperClass);
    $showPictureInfoBtn = $element.find(showPictureInfoBtnSelectorClass);
    $enlargePictureBtn = $element.find(enlargePictureBtnSelectorClass);
    $hashLinks = $element.find(hashLinks);
    $documentBody = $('body');
    $window = window;
  }

  function initDetailAdditionalSelectors() {
    $detailWrapper = $element.find(detailWrapperClass);
    $detailBackgroundImage = $element.find(backgroundImageSelectorClass);
    $detailVideoWrapper = $element.find(videoWrapperSelectorClass);
    $pictureContainer = $element.find(pictureContainerSelectorClass);
    $videoContainer = $element.find(videoContainerSelectorClass);
    $galleryDetailText = $element.find(acrGalleryDetailTextClass);
    $galleryDetailLightbox = $element.find(lightboxSelectorClass);
  }

  function initGlobalVariables() {
    acrDetailVideoPlayerList = [];
    acrDetailFilmstripItemClassName = acrDetailFilmstripItemClass;
    ieOrWinEdge = Utility.isIE11() || Utility.isWinEdge();
  }

  function createArrow(orientation, icon, className) {
    var $arrowContainer;
    var arrowContainer;
    var $svg;
    var svg;
    var use;
    var orientationTarget;
    var iconTarget;
    var customClass;

    orientationTarget = orientation !== undefined ? orientation : 'next';
    customClass = className !== undefined ? ' ' + className : '';
    iconTarget = icon !== undefined ? icon : arrowRightClass;
    svg = document.createElementNS(svgDefiniion, 'svg');
    $svg = $(svg);
    use = document.createElement('use');
    $svg.attr('class', 'acr-icon');
    $svg.attr('viewBox', '0 0 26 26');
    use.setAttribute('xlink:href', '#' + iconTarget);
    $svg.append(use);
    $svg.first().append(orientationTarget);

    arrowContainer = document.createElement('div');
    $arrowContainer = $(arrowContainer);
    $arrowContainer.attr('class', 'slick-arrow slick-' + orientationTarget + customClass);
    $arrowContainer.append($svg[0].outerHTML || new XMLSerializer().serializeToString($svg[0]).replace('NS1:', ''));

    return $arrowContainer[0].outerHTML;
  }

  function stopVideos() {
    for (var x = 0; x < acrDetailVideoPlayerList.length; x++) {
      var $target;
      $target = acrDetailVideoPlayerList[x];
      if ($target.stop != null) {
        $target.stop();
      }
    }
  }

  function pauseVideos() {
    for (var x = 0; x < acrDetailVideoPlayerList.length; x++) {
      var $target;
      $target = acrDetailVideoPlayerList[x];
      if ($target.stop != null) {
        $target.pause();
      }
    }
  }

  function startVideos() {
    for (var x = 0; x < $acrDetailVideoPlayer.length; x++) {
      var $target;
      var targetId;
      $target = $($acrDetailVideoPlayer[x]);
      targetId = $target.id;

      var videoID = $target.data('video-src');
      var container = $target;
      var autoplay = false;

      var player = new Acr.YouTubeManager.YouTubePlayerObject(videoID, null,
        container, container, autoplay);

      player.init();

      acrDetailVideoPlayerList[x] = player;
    }
  }

  function initDetailSlick() {
    // Init Slick for Detail Picture
    $acrDetailPictureSlick.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      infinite: true,
      responsive: [{
        breakpoint: 0,
        settings: {
          draggable: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          draggable: false,
        },
      },
      ],
      nextArrow: createArrow('next', arrowRightClass, acrDetailhoverClass),
      prevArrow: createArrow('prev', arrowLeftClass, acrDetailhoverClass),
    });
  }

  function initFilsmtripSlick(slidesToShowParam) {
    // Init Slick for Filmstrip
    $acrDetailFilmstripSlick.slick({
      slidesToShow: slidesToShowParam,
      variableWidth: true,
      slidesToScroll: 1,
      mobileFirst: true,
      infinite: true,
      dots: false,
      responsive: [{
        breakpoint: 0,
        settings: {
          draggable: true,
          arrows: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          draggable: false,
          arrows: false,
          slidesToScroll: 1,
        },
      },
      ],
    });
  }

  function modalResizeHandler() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $acrDetailFilmstripSlick.slick('unslick');
      attachFilmstripWidth();
    }, 250);
  }

  function attachFilmstripWidth() {
    // Calculate how many items can be displayed on the filmstrip, if the total images are less the
    // than the calculated number, the images will be centered on the available space
    var filmstripItemWidth;
    var filmstripItemLength;
    var filmstripWidth;
    var currentVisibleItems;
    const slideMargin = 5;

    filmstripItemWidth = $acrDetailFilmstripItem.width();
    filmstripItemLength = $acrDetailFilmstripItem.not('.slick-cloned').length;
    $acrGalleryDetailFilmstripWrapper.css('width', '');
    filmstripWidth = $acrDetailFilmstripSlick.width();
    currentVisibleItems = Math.round(filmstripWidth / (filmstripItemWidth + slideMargin));

    if (filmstripItemLength <= currentVisibleItems) {
      $acrGalleryDetailFilmstripWrapper.css('width', (filmstripItemLength * (filmstripItemWidth + slideMargin)));
    }
    initFilsmtripSlick(currentVisibleItems);
  }

  function attachKeyboardInput() {
    $(document).on('keyup', keyboardHandler);
  }

  function keyboardHandler(e) {
    switch (e.which) {
      case 27: // esc key
        closeHandler();
        break;
      case 37: // left arrow
        $acrDetailPictureSlick.slick('slickPrev');
        break;
      case 39: // right arrow
        $acrDetailPictureSlick.slick('slickNext');
        break;
    }
  }

  function bindInitialEvents() {
    initCloseBtn();
    initDeeplink();
    initPictureInfoBtns();
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    bindInitialEvents();
  }

  return {
    init: init,
    openDetailview: openDetailview,
  };
};
